module.exports = __webpack_public_path__ + "img/img15.54a5c13a.png";